
<template>
    <div class="common-box" :class="{'show': show}">
        <template v-for="(item,index) in configFixed">
            <div class="row" :key="index">
                <div
                    v-if="['UploadBtn'].includes(item.type)"
                    class="btns-box"
                >
                    <UploadBtn
                            v-if="authUpload"
                            :type.sync="type"
                            :class="{full: type !== 'audio'}"
                            :isPlat.sync="isPlat"
                            @success="success"
                    />
                    <LuyinBtn
                            ref="record"
                            v-if="type === 'audio' && authLuyin"
                            :is-shop="item.isShop"
                            @onLuyinBtn="onLuyinBtn"
                    />
                    <LuyinWxBtn
                            ref="wxRecord"
                            v-if="type === 'audio' && authLuyinWx"
                            :is-shop="item.isShop"
                            @onFlash="onFlash"
                    />
                    <LuyinAiBtn
                            ref="aiAudio"
                            v-if="type === 'audio' && authLuyinAi"
                            :is-shop="item.isShop"
                            @onFlash="onFlash"
                    />
                </div>
                <WordSelect
                        v-else-if="item.type === 'WordSelect'"
                        @onWordSelect="onWordSelect"
                />
                <div v-else class="row-pad">
                    <TypeBtn
                            v-if="item.type === 'TypeBtn'"
                            :form.sync="item.form"
                            :selected.sync="item.selected"
                            @onTypeBtn="onTypeBtn"
                    />
                    <CatalogType
                            ref="CatalogType"
                            v-if="item.type === 'CatalogType'"
                            :isFilter.sync="item.isFilter"
                            :type.sync="type"
                            :navTypes="navTypesData"
                            :catalogData="catalogData"
                            :selectCatalog.sync="selectCatalog"
                            :filterValue.sync="item.filterValue"
                            :selected.sync="item.selected"
                            :is-shop="isPlat"
                            @onSearchBox="onSearchBox"
                            @onFilterChange="onFilterChange"
                            @cancel="clearSearch"
                            @onSearch="()=>{getSearchData({perPage: 99})}"
                            @flashData="flashData"
                    />
                    <LuyinBtn
                            ref="record"
                            v-if="item.type === 'LuyinBtn' && authLuyin"
                            :is-shop="item.isShop"
                            @onLuyinBtn="onLuyinBtn"
                    />
                    <MoreBtn
                            v-if="item.type === 'MoreBtn' && isShow"
                            :type.sync="type"
                            :navId.sync="newNavId"
                            @onMoreBtn="onMoreBtn"
                    />
                    <SearchBox
                            v-if="item.type === 'SearchBox'"
                            :type.sync="type"
                            :value.sync="search"
                            :catalogData="catalogData"
                            :selectCatalog.sync="selectCatalog"
                            :is-shop="isPlat"
                            @onSearchBox="onSearchBox"
                            @cancel="clearSearch"
                    />
                    <SelectList
                            v-if="item.type === 'SelectList'"
                            :form.sync="item.form"
                            :selected.sync="item.selected"
                            :is-shop="item.isShop"
                            @onSelectList="onSelectList"
                            @closeBackAudio="$emit('closeBackAudio')"
                    />
                    <SelectTypes
                            v-if="item.type === 'SelectTypes'"
                            :form.sync="item.form"
                            :selected.sync="item.selected"
                            @onSelectTypes="onSelectTypes"
                    />
                    <TimesType
                            v-if="item.type === 'TimeTyes'"
                            :form.sync="item.form"
                            :selected.sync="item.selected"
                            @onTimesType="onTimesType"
                    />
                    <TypeList
                            v-if="item.type === 'TypeList'"
                            :form.sync="item.form"
                            :selected.sync="item.selected"
                            :isBackground="item.isBackground"
                            :type.sync="type"
                            :isPlat="isPlat"
                            @onTypeList="onTypeList"
                            @onTypeListImage="onTypeListImage"
                            @onBackground="onBackground"
                    />
                </div>
            </div>
        </template>
        <div class="content-txt">
            <template v-for="(item,index) in configNomal">
            <div
                    class="row"
                    :class="{more:item.type.indexOf('MoreBtn')>-1}"
                    :key="index">
                <UploadBtn
                    v-if="item.type === 'UploadBtn' && authUpload"
                    :type.sync="type"
                    :isPlat.sync="isPlat"
                    @success="success"
                />
                <WordSelect
                    v-else-if="item.type === 'WordSelect'"
                    @onWordSelect="onWordSelect"
                />
                <div v-else class="row-pad">
                    <TypeBtn
                            v-if="item.type === 'TypeBtn'"
                            :form.sync="item.form"
                            :selected.sync="item.selected"
                            @onTypeBtn="onTypeBtn"
                    />
                    <LuyinBtn
                        ref="record"
                        v-if="item.type === 'LuyinBtn' && authLuyin"
                        :is-shop="item.isShop"
                        @onLuyinBtn="onLuyinBtn"
                    />
                    <LuyinWxBtn
                        ref="wxRecord"
                        v-if="item.type === 'LuyinWxBtn' && authLuyinWx"
                        :is-shop="item.isShop"
                        @onFlash="onFlash"
                    />
                    <LuyinAiBtn
                        ref="aiAudio"
                        v-if="item.type === 'LuyinAiBtn' && authLuyinAi"
                        :is-shop="item.isShop"
                        @onFlash="onFlash"
                    />
                    <MoreBtn
                        v-if="item.type === 'MoreBtn' && isShow"
                        :type.sync="type"
                        :navId.sync="newNavId"
                        @onMoreBtn="onMoreBtn"
                    />
                    <SearchBox
                        v-if="item.type === 'SearchBox'"
                        :type.sync="type"
                        :catalogData="catalogData"
                        @onSearchBox="onSearchBox"
                    />
                    <SelectList
                        v-if="item.type === 'SelectList' && !isSearch"
                        ref="selectList"
                        :minHeight="contentHeight"
                        :form.sync="item.form"
                        :selected.sync="item.selected"
                        :is-shop="item.isShop"
                        @onSelectList="onSelectList"
                        @onMoreSelectList="onMoreTypeList"
                        @closeBackAudio="$emit('closeBackAudio')"
                    />
                    <SelectTypes
                        v-if="item.type === 'SelectTypes'"
                        :form.sync="item.form"
                        :selected.sync="item.selected"
                        @onSelectTypes="onSelectTypes"
                    />
                    <TimesType
                        v-if="item.type === 'TimeTyes'"
                        :form.sync="item.form"
                        :selected.sync="item.selected"
                        @onTimesType="onTimesType"
                    />
                    <TypeList
                        v-if="item.type === 'TypeList' && !isSearch"
                        ref="typelist"
                        :minHeight="contentHeight"
                        :loading.sync="isLoading"
                        :form.sync="item.form"
                        :selected.sync="item.selected"
                        :isBackground="item.isBackground"
                        :type.sync="type"
                        :isPlat.sync="isPlat"
                        @onTypeList="onTypeList"
                        @onTypeListImage="onTypeListImage"
                        @onMoreTypeList="onMoreTypeList"
                        @onBackground="onBackground"
                    />
                    <SearchList
                        v-if="item.type === 'SearchList' && isSearch"
                        ref="searchList"
                        :minHeight="contentHeight"
                        :loading.sync="isLoading"
                        :form.sync="searchData"
                        :type.sync="type"
                        :isPlat.sync="isPlat"
                        @onBack="clearSearch"
                        @onTypeList="onTypeList"
                        @onTypeListImage="onTypeListImage"
                        @onMoreTypeList="onMoreTypeList"
                        @onBackground="onBackground"
                    />
                </div>
            </div>
        </template>
        </div>
    </div>
</template>

<script>
    import { Loading } from 'element-ui'
    import { mapState } from 'vuex'
    import SearchList from './components/searchList'
    import UploadBtn from './components/uploadBtn'
    import WordSelect from './components/wordSelect'
    import TypeBtn from './components/typeBtn'
    import LuyinBtn from './components/luyinBtn'
    import LuyinWxBtn from './components/luyinWxBtn'
    import LuyinAiBtn from './components/luyinAiBtn'
    import MoreBtn from './components/moreBtn'
    import SearchBox from './components/searchBox'
    import SelectList from './components/selectList'
    import SelectTypes from './components/selectTypes'
    import TimesType from './components/timesType'
    import TypeList from './components/typeList'
    import CatalogType from './components/catalogType'
    import * as ResultServer from '../../../../../../api/resource'
    import * as commonServer from "../../../../../../api/common"
    import {upLoad} from '../../../../../../utils/upload'
    import {getRandomByObj} from "../../../../../../utils/utils"

    export default {
        name: "common",
        components: {
            SearchList,
            UploadBtn,
            WordSelect,
            TypeBtn,
            LuyinBtn,
            LuyinWxBtn,
            LuyinAiBtn,
            MoreBtn,
            SearchBox,
            SelectList,
            SelectTypes,
            TimesType,
            TypeList,
            CatalogType
        },
        props:{
            show: {
                type: Boolean,
                default: false
            },
            props: {
                navId: [String,Number]
            },
        },
        watch: {
            search: {
                handler(vl){
                    if(vl) {
                        this.searching()
                    }
                },
                deep: true
            },
            selectCatalog: {
                handler(vl){
                    if(vl) {
                        this.searching()
                    }
                },
                deep: true
            },
            isLoading(vl){
                if(vl){
                    this.loadingFn = Loading.service({
                        target: document.querySelector('.common-box'),
                        customClass: 'zhezhao2'
                    });
                }else{
                    this.$nextTick(() => {
                        this.loadingFn && this.loadingFn.close && this.loadingFn.close();
                    });
                }
            },
        },
        computed: {
            ...mapState(['menusData', 'menusDataIds']),
            isShow(){
                return this.show
            },
            getFormList(){
                return 'getFormList'
            },
            // 是否正在搜索
            isSearch(){
                let state = false
                if(this.search || this.selectCatalog) {
                    state = true
                }
                return state
            },
            // 是否有权限上传
            authUpload(){
                let state = false
                let isShop = this.isPlat
                switch (this.type) {
                    case 'scenes':
                        state = isShop?this.$store.state.permissions['meterial_scene_shop_add']:this.$store.state.permissions['meterial_scene_my_add']
                        break
                    case 'image':
                        state = isShop?this.$store.state.permissions['meterial_image_shop_add']:this.$store.state.permissions['meterial_image_my_add']
                        break
                    case 'audio':
                        state = isShop?this.$store.state.permissions['meterial_audio_shop_add']:this.$store.state.permissions['meterial_audio_my_add']
                        break
                    case 'animation':
                        state = isShop?this.$store.state.permissions['meterial_animate_shop_add']:this.$store.state.permissions['meterial_animate_my_add']
                        break
                    case 'video':
                        state = isShop?this.$store.state.permissions['meterial_video_shop_add']:this.$store.state.permissions['meterial_video_my_add']
                        break
                    default:
                }
                return state
            },
            // 是否有权限录音
            authLuyin(){
                return this.isPlat?this.$store.state.permissions['meterial_audio_shop_record']:this.$store.state.permissions['meterial_audio_my_record']
            },
            // 是否有权限录音 - 微信
            authLuyinWx(){
                return this.isPlat?this.$store.state.permissions['meterial_audio_shop_wx_record']:this.$store.state.permissions['meterial_audio_my_wx_record']
            },
            // 是否有权限录音 - AI
            authLuyinAi(){
                return this.isPlat?this.$store.state.permissions['meterial_audio_shop_ai_add']:this.$store.state.permissions['meterial_audio_my_ai_add']
            },
            isPlat(){
                return `${this.config[this.getIndexByType('TypeBtn')].selected}` === '2'
            },
            getResourceCategoryTree(){
                return this.isPlat?'getResourceCategoryShopTree':'getResourceCategoryTree'
            },
            getResourceList(){
                return this.isPlat?'getResourceShopList':'getResourceList'
            },
            configFixed(){
                return this.config.filter(v=>v.fixed)
            },
            configNomal(){
                return this.config.filter(v=>!v.fixed)
            }
        },
        created(){
            this.$nextTick(()=>{
                // 监听列表滚动事件
                this.listScroll()
                // 获取列表的可视高度
                this.getContentHeight()
            })
            window.onresize = ()=>{
                this.$nextTick(()=>{
                    const fn = setTimeout(()=>{
                        this.getContentHeight()
                        clearTimeout(fn)
                    }, 1000)
                })
            }
        },
        data(){
            return {
                contentHeight: 0, // 右边数据渲染的实际高度
                isLoading: false, // 数据是否正在加载
                loadingFn: null, // 加载事件
                tempTime: null, // 临时事件
                navTypesData: [], // 当前所有目录集合
                fn: null,
                searchData: [], // 搜索内容
                selectCatalog: '', // 当前选中的目录
                catalogData: null, // 目录内容
                search: '',
                type: '',
                config: [
                    {
                        type: 'WordSelect',
                        value: ''
                    },
                    {
                        type: 'TypeBtn',
                        value: ''
                    },
                    {
                        type: 'LuyinBtn',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                    {
                        type: 'SearchBox',
                        value: ''
                    },
                    {
                        type: 'CatalogType', // 目录类别选择
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'SelectList',
                        form: [
                            {
                                title: '分类一',
                                data: [
                                    {id:0, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                                    {id:1, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                                    {id:2, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                                    {id:3, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                                ]
                            }
                        ],
                        selected: []
                    },
                    {
                        type: 'SelectTypes',
                        form: [
                            {id: 0, name: '大气是短发是短发'},{id: 2, name: '大气'},{id: 3, name: '大气'},{id: 4, name: '大气'},
                            {id: 5, name: '大气'},{id: 6, name: '大气'},{id: 7, name: '大气'},{id: 8, name: '大气'},
                            {id: 9, name: '大气'},{id: 99, name: '大气'},{id: 999, name: '大气'},{id: 99999, name: '大气'},
                            {id: 909, name: '大气'},{id: 6, name: '大气'},
                        ],
                        selected: []
                    },
                    {
                        type: 'TimeTyes',
                        form: [{value: 10, label: '全部时长'}],
                        selected: []
                    },
                    {
                        type: 'TypeList',
                        form: [
                            {
                                title: '场景类型',
                                data: [
                                    {url: this.$images.contents.datu, love: false},
                                    {url: this.$images.contents.datu, love: true},
                                    {url: this.$images.contents.datu, love: false},
                                    {url: this.$images.contents.datu, love: false},
                                    {url: this.$images.contents.datu, love: false},
                                    {url: this.$images.contents.datu, love: false},
                                ],
                                column: 2,
                            }
                        ],
                        selected: [0]
                    },
                ],
                newNavId: this.navId || ''
            }
        },
        methods: {
            getContentHeight(){
                this.contentHeight = 0
                try {
                    this.$nextTick(()=>{
                        const div = document.querySelector('.common-box .content-txt')
                        if(div) this.contentHeight = div.clientHeight
                    })
                } catch (e) {
                    console.log('contentHeight==>', e)
                }
            },
            scrollTodo(e){
                let child = document.querySelector('.content-txt>.row')
                const scrollTop = e.target.scrollTop
                const boxHeight = e.target.clientHeight
                let contentHeight = child.clientHeight

                console.log('1==>', scrollTop)
                console.log('2==>', boxHeight)
                console.log('3==>', contentHeight)

                // 判断是否是搜索组件
                const isSearch = !contentHeight
                if(isSearch){
                    child = document.querySelector('.search-list')
                    contentHeight = child.clientHeight
                }
                console.log('4==>', contentHeight)
                console.log('5==>', scrollTop >= contentHeight - boxHeight)
                console.log('6==>', isSearch)

                // 1.如果 滚动的距离 === 文本实际渲染高度【contentHeight】 - 浏览器可视高度【boxHeight】
                // 2.加载下一页
                if(
                    scrollTop >= contentHeight - boxHeight
                ){
                    const fn = ()=>{
                        console.log('是否下一页==>', this.$refs.typelist, this.$refs.searchList, this.$refs.selectList)
                        this.$refs.typelist &&
                        this.$refs.typelist[0] &&
                        this.$refs.typelist[0].scrollTodo &&
                        this.$refs.typelist[0].scrollTodo()

                        this.$refs.searchList &&
                        this.$refs.searchList[0] &&
                        this.$refs.searchList[0].scrollTodo &&
                        this.$refs.searchList[0].scrollTodo()

                        this.$refs.selectList &&
                        this.$refs.selectList[0] &&
                        this.$refs.selectList[0].scrollTodo &&
                        this.$refs.selectList[0].scrollTodo()
                    }
                    if(isSearch) {
                        fn()
                    } else {
                        if(!this.tempTime){
                            this.tempTime = true
                            fn()
                        }
                        const time = setTimeout(()=>{
                            this.tempTime = false
                            clearTimeout(time)
                        }, 1000)
                    }
                }
            },
            // 监听列表滚动事件 - 如果滚动到底判断是否有下一页
            listScroll(){
                const div = document.querySelector('.content-txt')
                div.addEventListener("scroll", this.scrollTodo)
            },
            onFlash(){
                this.flashData()
            },
            init(){
                // 如果当前为公共用户进入
                if(this.$store.getters.isPlat){
                    let index = this.getIndexByType('TypeBtn')
                    this.config[index].selected = 2
                    this.onTypeBtn(2)
                    return false
                }
                this.flashData()
            },
            // 正在搜索
            searching(){
                clearTimeout(this.fn)
                this.fn = setTimeout(()=>{
                    if(!this.selectCatalog && !this.search){
                        return false
                    }
                    this.getSearchData({perPage: 99})
                },300)
            },
            // 获取搜索数据
            async getSearchData({perPage}) {
              let list = []
                this.isLoading = true
                try {
                  let obj = {perPage, page: 1, is_online: this.isPlat?1:0, is_push: this.isPlat?1:0}
                  let getList = this.getResourceList
                  let data = null
                  // if (this.selectCatalog)
                  obj.categoryId = this.selectCatalog
                  if (this.search) obj.search = this.search

                  let newObj = this.getCurObj(obj)
                  console.log("开始搜索数据：",newObj);

                  if(this.type === 'game')getList = 'getGameList'
                  data = await commonServer.default[getList](newObj)

                  if(this.type === 'game') {
                      // 游戏搜索，必须关联出所有场景
                      let newArr = []
                      let sesScene
                      let arr = data.items
                      for(let i = 0, len = arr.length; i < len; i++) {
                          /*sesScene = await commonServer.default[this.getFormList]({
                              page: 1,
                              categoryId: arr[i].form_category_id_scenes,
                              perPage: 6
                          })*/
                          sesScene=arr[i].form_category_scenes_list;
                          //sesScene.items.map(q=>{
                          sesScene.map(q=>{
                              newArr.push({
                                  ...arr[i],
                                  form_id_scenes: q.id,
                                  alias: `${arr[i].alias}-${q.name}`,
                                  url: this.getImg(q.options)
                              })
                          })
                          this.searchLastPage = data.meta.last_page
                      }
                      list = newArr
                  } else {
                      this.searchLastPage = data.meta.last_page
                      list = this.getResultData(data.items)
                  }
                }catch (e) {
                    console.log('获取搜索数据失败==>', e)
                }
              this.searchData = list

              this.isLoading = false
            },
            // 清除搜索
            clearSearch(){
                this.search = ''
                this.selectCatalog = ''
            },
            // 获取当前是否选中公共
            getIsPlat(){
                return `${this.config[this.getIndexByType('TypeBtn')].selected}` === '2'
            },
            async flashData(initial){
                this.isLoading = true
                let column = 2
                let listType = 'TypeList'
                let getResourceTree = this.getResourceCategoryTree
                let getList = this.getResourceList
                switch (this.type) {
                    case 'audio':
                        column = 1
                        listType = 'SelectList'
                        break
                    case 'video':
                        column = 2
                        break
                    case 'game':
                        column = 2
                        getResourceTree = this.getGameCategoryTree
                        getList = 'getGameList'
                        break
                    default:
                }

                let index = this.getIndexByType(listType)
                // console.log('shop=====>', this.config[this.getIndexByType('TypeBtn')])
                // 获取所有的动画一级目录
                const res = await commonServer.default[getResourceTree]({
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type
                })
                console.log('获取列表分类==>', res.data)

                // 获取分类
                this.catalogData = res.data.filter(v=>v.res_count > 0)

                this.config[index].selected = []

                this.config[index].form = res.data.filter(v=>v.parent_id === 0 && v.res_count > 0).map(q=>{
                    return {
                        title: q.name,
                        column,
                        data: [],
                        ...q,
                    }
                })
                console.log("this.config[index]",this.config[index]);

                let obj = {}
                Array.isArray(this.config[index].form) && this.config[index].form.unshift({
                    id: '',
                    sort: this.type,
                    name: '所有',
                    title: '所有',
                    column: this.type === 'audio'?1:2,
                    data: [],
                    childrens: []
                })
                this.config[index].form.map(async (v,i)=>{
                    obj = this.getCurObj({
                        categoryId: v.id,
                        perPage: 16,
                        page: 1
                    })
                    if(this.isPlat){
                        obj.is_online = 1
                        obj.is_push = 1
                    }

                    // 数据请求地址 & 参数
                    v.apiConfig = {
                        params: obj,
                        request: commonServer.default[getList]
                    }

                    if(i===0) {
                        // 设置默认选中分类 (图片默认场景图分类，动画默认人物分类，游戏默认选择题分类)
                        let defaultSelectedType = ''
                        let indexCatalogType = -1
                        this.config.map((v, i)=>{
                            if(v.type === 'CatalogType'){
                                indexCatalogType = i
                            }
                        })
                        this.config[index].form.map(v=>{
                            switch (this.type) {
                                case 'image':
                                    if(['场景图'].includes(v.title)){
                                        defaultSelectedType = v.id
                                    }
                                    break
                                case 'animation':
                                    if(['人物'].includes(v.title)){
                                        defaultSelectedType = v.id
                                    }
                                    break
                            }
                        })
                        if(defaultSelectedType && !initial){
                            obj.categoryId = defaultSelectedType
                            this.selectCatalog = defaultSelectedType
                            this.config[indexCatalogType].selected = defaultSelectedType
                        }

                        let data = await commonServer.default[getList](obj)

                        console.log("首次加载数据：",getList,obj);

                        v.data = this.getResultData(data.items)
                        v.page = data.meta.current_page
                        v.last_page = data.meta.last_page

                        // 如果第一个数据有值默认选中第一个展开
                        // if(v.data && v.data.length>0) {
                        this.config[index].selected = [i]
                        // }
                    }
                })

                this.navTypesData = this.config[index].form

                this.isLoading = false

            },
            getIndexByType(type){
                let index = -1
                this.config.map((v,i)=>{
                    if(v.type === type) index = i
                })
                return index
            },
            success(){
                this.flashData()
            },
            onWordSelect(item){
                // 游戏环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                console.log('通知cocos添加字体==>', item)
                // this.$toCocosMessage({type: 'AddResource',value: {type: 'word', config: item}})
                let obj = {type: 'word',familySelect: 'Microsoft YaHei', fontSize: 24, text: item.name, html: item.name, shangxia: 10}
                switch (item.type) {
                    case 'h1':
                        obj.fontSize = 24 * 2
                        obj.b = true
                        break;
                    case 'h2':
                        obj.fontSize = 20 * 2
                        obj.b = true
                        break;
                    case 'h3':
                        obj.fontSize = 20 * 2
                        break;
                    case 'text':
                        obj.fontSize = 22
                        obj.type= 'text'
                        obj.shangxia=1.5
                        obj.lineHeight=1.5
                        obj.html='文字局部<font style="font-size: 44px;">大小</font>/<font color="#ff0000">颜色</font>修改';
                        obj.text='文字局部<size=44>大小</size>/<color=#ff0000>颜色</color>修改';
                        break;
                }
                this.$toCocosMessage({type: 'AddResource',value: obj})
            },
            onTypeBtn(value){
                this.clearSearch()
                setTimeout(()=>{
                    const div = document.querySelector('.content-txt')
                    div.scrollTop = 0
                    this.selectCatalog = ''
                    this.$emit('onTypeBtn', value)
                    this.config.map(v=>{
                        v.isShop = this.isPlat
                    })
                    //console.log('选择公共后==>', this.config)
                    this.flashData()
                })
            },
            onLuyinBtn(obj){
                console.log('录音==>')
                this.$emit('onLuyinBtn')

                // 上传服务器
                upLoad({
                    fileName: obj.name + '.mp3',
                    file: obj.row,
                    callback: async (res)=>{
                        try {
                            // 上传音频文件
                            let addResource = obj.isShop?'addResourceShop':'addResource'
                            const result = await commonServer.default[addResource]({
                                ...obj,
                                clientsId: this.$store.state.initConfig.school_id,
                                sort:'audio',
                                attributes: {
                                    type: 'flash',
                                    cover: 'default.jpg',
                                    remotepath: res.split('.com/')[1],
                                    md5: res.split('.com/')[1].replace('.mp3', '')
                                }
                            })
                            // console.log(result.status_code)
                            // debugger
                            if(result.status_code === 200){
                                this.flashData()
                                this.$refs.record && this.$refs.record[0].close()
                            } else {
                                this.$message.error(result.message)
                            }
                        }catch (e) {
                            // this.$message.error('上传音频失败')
                        }
                    }
                })

            },
            onMoreBtn(obj){
                console.log('更多==>')
                this.$emit('onMoreBtn', obj)
            },
            onSearchBox(value){
                console.log('搜索==>')
                this.$emit('onSearchBox', value)
            },
            onFilterChange(value){
                this.gameType = value
                const enums = {
                    tools: 'tools',
                    game: 'io'
                }
                this.getSearchData({perPage: 9999, gtype: enums[this.type]})
            },
            onSelectList(data){
                console.log('选择列表1==>', data)
                // this.$emit('onSelectList', data)
            },
            onSelectTypes(data){
                console.log('选择类型==>')
                this.$emit('onSelectTypes', data)
            },
            onTimesType(value){
                console.log('时长选择==>')
                this.$emit('onTimesType', value)
            },
            async onTypeList(item, data, style){
                console.log('类型列表==>', this.type, item, data, style)
                if(['game'].includes(this.type)) {
                    // 添加游戏必须必须要有菜单导航
                    if(!this.$store.state.menusData.blocksSelected){
                        this.$message.warning('您还未创建导航')
                        return false
                    }

                    // 添加游戏提示支持类型
                    const {is_double_teacher, is_offline, is_online, is_exercise} = item
                    const arr = []
                    if(is_offline) arr.push('线上直播')
                    if(is_online) arr.push('线下白板')
                    if(is_double_teacher) arr.push('线下答题器')
                    if(is_exercise) arr.push('课后练习')
                    const str = `支持场景有：${arr.join('、')}课程`
                    if(arr && arr.length){
                        this.$message.success(str)
                    }

                    this.$store.dispatch('setSaving', true)
                    // this.$store.dispatch('setIsBuilding', true)
                    console.log('游戏共建中测试==>1')
                }
                this.$emit('onTypeList', item, data, style)

                // 模版替换
                if(this.type === 'template'){
                    let obj={id:item.id,clientsId:this.$store.state.initConfig.school_id};
                    const res = (this.isPlat)?await ResultServer.getResourceShopDetail(obj):await ResultServer.getResourceDetail(obj);
                    if(res.status_code === 200){
                        let menusData = this.menusData
                        let curBlockForms = this.menusData.blocksForm
                        let copyedBlockForms = res.data.attributes.h5_remote.blocksForm || []
                        // 更新下unique
                        copyedBlockForms = this.$utils.addUniqueByArr({data: copyedBlockForms})
                        const templateData = this.$_.cloneDeepWith(copyedBlockForms)

                        // let blockForms = curBlockForms.concat(copyedBlockForms)
                        let blockForms = curBlockForms
                        Array.prototype.push.apply(blockForms, copyedBlockForms)
                        menusData.blocksForm = blockForms

                        const newData = this.$utils.one2TwoTree({data: this.$_.cloneDeepWith(menusData), ids: this.menusDataIds})
                        menusData = newData.menusData

                        // 获取实际映射的ids列表
                        const {menusIds} = this.$utils.one2TwoTree({data: {...menusData, blocksForm: this.$_.cloneDeepWith(templateData)}, ids: this.menusDataIds})
                        this.$store.state.menusDataIds = {...this.$store.state.menusDataIds, ...menusIds}

                        // TODO 合并课件
                        const operation = [
                            {data:templateData,operation: 'merge'}
                        ]
                        $eventBus.$emit('__save__',true,null, operation)
                        console.log('操作==>合并课件', operation)

                        // 如果菜单未选中，默认选中第一个场景第一个课件
                        if(!menusData.blocksSelected || !menusData.lessonSelected || menusData.lessonSelected === '0/0') {
                            menusData.blocksSelected = this.$utils.getFirstMenu({data: menusData.blocksForm});
                            let node = this.menusDataIds[menusData.blocksSelected]
                            if(node && node.children && node.children.length){
                                menusData.lessonSelected = node.children[0].unique
                            } else {
                                menusData.lessonSelected = ''
                            }
                        }

                        let curH5Original = this.$store.state.urlMap
                        let copyH5Original = res.data.attributes.h5_remote.urlMap || []
                        // let h5_original = curH5Original.concat(copyH5Original)
                        let h5_original = curH5Original
                        Array.prototype.push.apply(h5_original, copyH5Original)

                        this.$store.dispatch('setMenusData', this.$_.cloneDeepWith(menusData))
                        this.$store.dispatch('setNewUrlMap', this.$_.cloneDeepWith(h5_original))

                        // 重新向cocos 发一次当前选中配置
                        try {
                            if (this.$store.state.menusData.blocksForm.length === 0) {
                                return false
                            }
                            // let data = this.$store.state.menusData.blocksForm.length>0?this.$store.state.menusData: this.newMenusData
                            // let arr = data.lessonSelected.split('/')
                            // // setTimeout(()=>{
                            // let value = data.blocksForm[arr[0]].children[arr[1]]
                            console.log('优化速度==>onTypeList')
                            let node = this.menusDataIds[this.menusData.lessonSelected] // this.$utils.getObjByCurLesson({})
                            console.log('完成加载==>')
                            console.log('优化速度->模版替换==>GetLessonConfig')
                            console.log('retro=>向cocos发配置9')
                            this.$store.dispatch('setIsBuilding', true)
                            this.$toCocosMessage({type: 'GetLessonConfig', value: getRandomByObj(node)})
                            // },300)
                        }catch (e) {
                            console.log('等待向cocos发配置==>', e)
                        }
                        
                    }
                    return false;
                }

                // 向cocos通知 添加资源
                /**
                 game: 游戏
                 resources: 资源
                 shop-resources: 公共资源（资源商城）
                 * */
                let type = 'resources'
                if(this.isPlat) type = 'shop-resources'
                if(['game', 'tool'].includes(this.type)) type = 'game'

                let md5 = this.$md5(type+item.id)

                // 计费路径
                let newUrl = item.url
                let newItem = {}
                if(['animation'].includes(this.type)){
                    newUrl = item.attributes.resources.url
                    // newUrl = newUrl.replace('https','http')
                    let obj = {} // this.$utils.getObjByArr({data: item.attributes.form_data})
                    // 获取最新的表单地址 如果存在form_id
                    if(item.attributes.form_id){
                        const id = item.attributes.form_id
                        const res = await commonServer.default.getFormDetail({ id })
                        // 获取 表单模版
                        obj = this.$utils.getObjByArr({data: this.$utils.getArrByDiy({ obj: res.data.options })})
                        console.log('获取最新表单模版==>', obj, res)
                    }
                    newItem = Object.assign({}, newItem, obj)
                    newItem.name = item.name
                    if(item.attributes.background_audio) newItem.background_audio = item.attributes.background_audio
                    if(item.attributes.background_img) newItem.background_img = item.attributes.background_img
                    if(['cocos', 'flash'].includes(item.attributes.type)){
                        newItem.type = item.attributes.type
                    }
                    // 动画更多配置
                    let list = item.bind_list
                    if(Array.isArray(item.bind_list)){
                        list = list.map(v=>{
                            return this.getMoreAnimation(v)
                        })
                    }
                    newItem.list = list
                }
                // 游戏的话，通过表单id 获取表单真实配置
                let theme = {}
                if(['game', 'tools'].includes(this.type)){
                    let resCommon = null
                    let resQuestion = null
                    let resScenes = null
                    if (item.form_id_common) {
                        resCommon = await commonServer.default.getFormDetail({id:item.form_id_common})
                        newItem.form_id_common = item.form_id_common
                    }
                    if (item.form_id_question) {
                        resQuestion = await commonServer.default.getFormDetail({id:item.form_id_question})
                        newItem.form_id_question = item.form_id_question
                    }
                    if (item.form_id_scenes) {
                        resScenes = await commonServer.default.getFormDetail({id:item.form_id_scenes})
                        newItem.form_id_scenes = item.form_id_scenes
                    }
                    console.log('youxi==>', resCommon, resQuestion, resScenes)
                    newItem.name = item.alias || item.name
                    newItem.mark = item.mark
                    newItem.question_type = item.question_type
                    newItem.is_double_teacher = item.is_double_teacher
                    newItem.is_push = item.is_push
                    newItem.is_offline = item.is_offline
                    theme = {background: {url: '', type: 'image'}}

                    if(['game'].includes(this.type)){
                        console.log('优化速度==>game选中')
                        newItem['cocosGameBackgroundImage'] = item.url || item.cover
                        // 添加游戏 清除历史游戏配置
                        this.$store.state.editGameConfig = null
                    }

                    if(resCommon) {
                        const config_common_original = this.$utils.getArrByDiy({obj: resCommon.data.options})
                        newItem.config_common = this.$utils.getObjByArr({data: config_common_original})

                        // 特殊处理，如果通用配置中存在 rawConfig 就将其系列化
                        if(newItem.config_common.rawConfig && typeof newItem.config_common.rawConfig === 'string') {
                            newItem.config_common.rawConfig = JSON.parse(newItem.config_common.rawConfig)
                        }

                        // 将场景配置直接复合到默认游戏配置中
                        if(newItem.config_common[`rawConfig-${item.form_id_scenes}`]){
                            newItem.config_common = {rawConfig: newItem.config_common[`rawConfig-${item.form_id_scenes}`]}
                        }
                    }
                    if(resQuestion) {
                        const config_question_original = this.$utils.getArrByDiy({obj: resQuestion.data.options})
                        newItem.config_question = this.$utils.getObjByArr({data: config_question_original})
                    }
                    if(resScenes) {
                        const config_scenes_original = this.$utils.getArrByDiy({obj: resScenes.data.options})
                        newItem.config_scenes = {name: resScenes.data.name, id: resScenes.data.id, type: 'gameScenes' }
                        newItem.config_scenes.config = this.$utils.getObjByArr({data: config_scenes_original})
                    }
                    newItem.form_category_id_scenes = item.form_category_id_scenes
                    newItem.md5 = md5
                    // newUrl = item.attributes.resources.url
                }

                // 默认场景设置
                let obj = {}
                if(this.type === 'scenes'){
                    this.setDefaultScene(item.attributes.options, md5)
                }else {
                    if(this.type === 'game'){
                        const unique1 = Math.random()
                        obj = { theme, config: newItem, type: style || this.type, unique: unique1}

                        this.menusDataIds[unique1] = this.$_.cloneDeepWith(obj)

                        // 先保存一次
                        let unique = Math.random()
                        this.$store.state.addGameTempObj = {unique, data:this.menusDataIds[unique1]}
                        delete obj.config
                        this.$toCocosMessage({type: 'SaveConfig', value: {flag: {type: 'addGame', unique}}})

                        // TODO 添加游戏
                        // console.log('优化速度==>添加游戏')
                        // const curNode =  this.$utils.getObjByCurLesson({data: this.$store.state.menusData.blocksForm, unique: this.$store.state.menusData.lessonSelected})
                        // const nodeBlock = this.$utils.curSelectedNode({})
                        // const newObj = {node: 'children', toUnique:curNode && curNode.unique,data:obj,leafUnique:nodeBlock.unique, operation: 'add'}
                        // const operation = [newObj]

                        // $eventBus.$emit('__save__',true,null, operation)
                        // console.log('操作==>合并课件', operation)

                        // 在当前课程下 新建一个空课程
                        // this.$store.dispatch('addOneMenuData', obj)
                    } else if(this.type === 'tools'){
                        obj = {config: newItem, type: style || this.type}
                        this.$toCocosMessage({type: 'AddResource', value: obj})
                    } else {
                        obj = {...newItem, type: newItem.type || style || this.type, url: newUrl, category_id: item.category_id}
                        console.log('animation02==>', obj, newItem.type,newItem,item)
                        // const node = this.$utils.getObjByCurLesson({})
                        // node.config.cocosGameBackgroundImage = obj.url
                        // console.log('nono==>', node)
                        // node.config

                        const node = this.menusDataIds[this.menusData.lessonSelected]
                        console.log('node==>cocosGameBackgroundImage', node)
                        //if(node && node.config) node.config['cocosGameBackgroundImage'] = obj.url

                        // 如果是添加视频，提示视频弹窗
                        if(obj?.type === 'video') $eventBus.$emit('showWarnInfo', this.$enums.warnInfo.addVideo)

                        this.$toCocosMessage({type: 'AddResource', value: obj})

                        if(this.menusDataIds[this.menusData.lessonSelected] && ['background', 'backgroundVideo'].includes(style)) {
                            this.$store.state.waitBackgourndVideo = true
                            $eventBus.$emit('onFlashLesson', true, null)
                        }
                        // 动画也会刷新课件背景
                        else if(['animation'].includes(this.type)) {
                            console.log('animation==>flashLesson')
                            const fn = setTimeout(()=>{
                                $eventBus.$emit('onFlashLesson', true, null)
                                clearTimeout(fn)
                            }, 1000)
                        }
                    }
                }
                console.log('发送给cocos数据common==>', obj)

                let url = ''
                if(['scenes', 'game', 'tools'].includes(this.type)){
                    // 游戏 使用type+id 生成对应md5
                    url = md5
                }else{
                    url = this.$utils.getAllMd5({data: newUrl})[0]
                }
                this.$store.dispatch('setUrlMap',{mark:'service-map-object', type, id: item.id,url})
            },
            // 获取动画的更多配置
            getMoreAnimation(item){
                let newUrl = item.url
                let newItem = {}
                newUrl = item.attributes.resources.url
                // newUrl = newUrl.replace('https','http')
                let obj = {} // this.$utils.getObjByArr({data: item.attributes.form_data})
                // 获取最新的表单地址 如果存在form_id
                if(item.attributes.form_data){

                    // TODO 实时拿最新的动画模版配置

                    // const id = item.attributes.form_id
                    // const res = await commonServer.default.getFormDetail({ id })
                    // 获取 表单模版
                    obj = this.$utils.getObjByArr({data: item.attributes.form_data})
                    console.log('获取最新表单模版==>', obj)
                }
                newItem = Object.assign({}, newItem, obj)
                newItem.name = item.name
                if(item.attributes.background_audio) newItem.background_audio = item.attributes.background_audio
                if(item.attributes.background_img) newItem.background_img = item.attributes.background_img
                if(['cocos', 'flash'].includes(item.attributes.type)){
                    newItem.type = item.attributes.type
                }
                return {...newItem, type: this.type, url: newUrl}
            },
            onTypeListImage(item){
                this.onTypeList(item, null, 'background')
            },
            // 更多
            async onMoreTypeList(item) {
                console.log('更多数据==>', item)
                this.isLoading = true
                // debugger

                // 往当前目录，追缴数据
                let page = 2
                if(item.page) page = item.page + 1
                let obj = {}
                let data = null
                let appendData = []
                let getList = this.getResourceList

                //getList = 'getGameList'
                if(this.type === 'game'){
                    // 如果是游戏，先获取游戏场景，填入游戏列表
                    data = await commonServer.default.getFormList({
                        page: page,
                        categoryId: item.data[0].form_category_id_scenes,
                        perPage: 20
                    })
                    appendData = this.getResultData(data.items, item.data[0])
                } else {
                    obj = this.getCurObj({categoryId: item.id || this.selectCatalog, perPage: 20, page})
                    // 如果是公共平台，只有上架才显示
                    if (this.getIsPlat()) obj['is_online'] = 1
                    data = await commonServer.default[getList](obj)
                    appendData = this.getResultData(data.items)
                }

                try {
                    item.page = page
                    item.last_page = data.meta.last_page
                }catch (e) {
                    console.log('获取最后一页失败==>', e)
                }

                console.log('追加数据==>', appendData)
                if(appendData.length === 0){
                    this.$message.warning('没有更多数据了')
                    return false
                }


                let listType = 'TypeList'
                switch (this.type) {
                    case 'audio':
                        listType = 'SelectList'
                        break
                    default:
                }
                let index = this.getIndexByType(listType)

                this.config[index].form.map(v=>{
                    if(`${v.id}` === `${item.id}`){
                        v.page = page
                        v.data = v.data.concat(appendData)
                    }
                })

                this.isLoading = false

            },
            // 设为背景视频
            onBackground(item, type){
                // 游戏环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                console.log('设为背景视频==>', item, type)
                $eventBus.$emit('showWarnInfo', this.$enums.warnInfo.addVideoBackground)
                this.onTypeList(item, null, type)

                // 当设为视频背景时，需要等待cocos保存后才刷新菜单课件列表
                this.$store.state.waitBackgourndVideo = true
            },
            // 获取配置参数
            getCurObj({categoryId,perPage, page, ...params}){
                let obj = {}
                obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type,
                    categoryId,
                    perPage,
                    page,
                    ...params
                }

                // 判断当前类型
                switch (this.type) {
                    // 场景
                    case "scenes":
                        obj['scenesStageId'] = this.navId
                        break
                    default:
                }


                // if (this.search) {
                //     obj.search = this.search
                // }
                return obj
            },
            // 搜索出来的数据转成展示数据
            getResultData(arr, oldArr){
                let url = ''

                // 如果是游戏,则关联场景出来
                if (oldArr) {
                    return arr.map(q=>{
                        return {
                            ...oldArr,
                            form_id_scenes: q.id,
                            alias: `${oldArr.alias.split('-')[0]}-${q.name}`,
                            url: this.getImg(q.options)
                        }
                    })
                }
                return arr.map(q => {
                    url = q.attributes && q.attributes.resources && q.attributes.resources.url
                    if (q.attributes && q.attributes.cover) url = q.attributes.cover
                    if (q.attributes && q.attributes.h5_remote) url = q.attributes
                    return {
                        url: url, //+ '?imageMogr2/thumbnail/!50p',
                        ...q
                    }
                })
            },
            // 根据游戏配置获取图片
            getImg(str) {
                let url = ''
                try {
                    let obj = JSON.parse(str)
                    // console.log(obj)
                    // debugger
                    obj.layout.map(v=>{
                        if(v.config && v.config[0].attr === 'cover'){
                            url = v.config[0].value
                        }
                    })
                }catch (e) {
                    console.log('等待获取背景图==>', e)
                }
                return url
            },
            // 设置默认场景
            setDefaultScene(data, md5){
                let form = this.$store.state.menusData.blocksForm
                console.log('111==>', data, form, md5)

                // 1.将场景格式[{xx:xx},{yy:yy}] 改成 {xx:xx, yy:yy}
                // 2.递归遍历菜单配置，将默认场景图覆盖
                // 3.向cocos通知最新选中的课程配置
                let oldData = this.$utils.arr2Obj({arr: data})
                this.$utils.setDefaultTheme({data: form, oldData, md5})

                // console.log(form)
                // debugger

                // 通知cocos侧刷新配置
                console.log('优化速度==>setDefaultScene')
                let node = this.menusDataIds[this.menusData.lessonSelected]
                console.log('优化速度setDefaultScene==>GetLessonConfig')
                console.log('retro=>向cocos发配置10')
                this.$store.dispatch('setIsBuilding', true)
                this.$toCocosMessage({type: 'GetLessonConfig',value: getRandomByObj(node)})
            }
        }
    }
</script>

<style>
.zhezhao2{
    background-color: rgba(0,0,0,.1);
}
.zhezhao2 .el-loading-spinner .circular{
    width: 18px;
}
.zhezhao2 .el-loading-spinner .path{
    stroke-width: 6px;
    stroke: white !important;
}
</style>
<style lang="scss">
.common-box{
    width: 296px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 54px);
    transition: all .5s .5s linear;

    .content-txt {
        display: flex;
        /*height: 300px;*/
        flex: 1;
        flex-direction: column;
        overflow-y: auto;
    }

    .row{
        display: flex;
        flex-shrink: 0;

        .btns-box{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 0px 20px;
            justify-content: space-between;
            width: calc(100% - 40px);

            &>div{
                display: flex;
                padding: 0px;
                min-width: 122px;
                width: initial;

                &.btn-box{
                    width: 122px;
                }
                &.full{
                    width: 100%;
                }

                .btn {
                    width: 100%;
                    margin-left: 0;
                    margin-right: 0;
                }
            }
        }

        &.more{
            position: absolute;
            bottom: -30px;
            margin-left: 20px;
        }

        .row-pad{
            padding: 0px 20px;
            width: calc(100% - 30px);
            /*padding-right: 16px;*/
        }
    }
}
</style>